'use strict';
const content = require('@mindmup/mapjs-core/src/content/content'),
	cleanUpContentForExport = require('./clean-up-content-for-export');
module.exports = function MapContentExporter(assetLocaliser, collaborationModel, mapModel, themeProvider, nodeViewModel, optional) {
	const getRootToClone = function (exportProps) {
			const rootToClone = collaborationModel.getActiveContent();
			if (exportProps && exportProps.export && exportProps.export.startFromSelected) {
				return rootToClone.findSubIdeaById(mapModel.getSelectedNodeId()) || collaborationModel.getActiveContent();
			} else if (exportProps?.export?.startFrom) {
				return rootToClone.findSubIdeaById(exportProps?.export?.startFrom) || collaborationModel.getActiveContent();
			} else {
				return rootToClone;
			}
		},
		getMapTitle = function () {
			const activeContent = collaborationModel.getActiveContent();
			return activeContent.title || activeContent.findSubIdeaById(activeContent.getDefaultRootId()).title;
		},
		removeEmbeddedResources = function (localisedContent) {
			if (localisedContent && localisedContent.resources) {
				localisedContent.resources = undefined;
			}
			return localisedContent;
		},
		makeExportable = function (exportProps, exportConfiguration) {
			const rootToClone = getRootToClone(exportProps),
				mapTitle = rootToClone.title || getMapTitle(),
				contentClone = cleanUpContentForExport(content(JSON.parse(JSON.stringify(rootToClone)))),
				localiserOptions = (optional && optional.localiserOptions) || (exportConfiguration && {
					imageScale: !exportConfiguration.free && exportProps && exportProps.export && parseFloat(exportProps.export.scale),
					sendSignedGoldAsserUrls: !!exportConfiguration.sendSignedGoldAsserUrls
				}),
				localiseTheme = () => {
					if (contentClone.attr && contentClone.attr.themeOverrides) {
						delete contentClone.attr.themeOverrides;
					}

					if (exportProps && exportProps.export && exportProps.export.imageBackground) {
						contentClone.theme = JSON.parse(JSON.stringify(themeProvider.getThemeJSON({
							canvas: {
								backgroundColor: exportProps.export.imageBackground,
							}
						})));
						if (contentClone?.theme?.canvas?.icon) {
							delete contentClone.theme.canvas.icon;
						}
					} else {
						contentClone.theme = themeProvider.getThemeJSON();
					}
				};
			contentClone.title = mapTitle;
			if (!optional || !optional.literalTheme) {
				localiseTheme();
			}
			//TODO: allow themes to be copied to the linked sub map - some problems with progress maps for example
			// else if (exportProps?.export?.startFromSelected) {
			// 	const contentOri = collaborationModel.getActiveContent(),
			// 		attr = JSON.parse(JSON.stringify(contentOri?.attr || {}));

			// 	contentClone.attr = Object.assign({}, contentClone.attr, attr);
			// }

			if (nodeViewModel) {
				contentClone.labels = nodeViewModel.getLabelMap();
			}
			return assetLocaliser.localise(contentClone, localiserOptions).then(removeEmbeddedResources);
		};
	Object.assign(this, {makeExportable});
};
